(ns minorodata.components.errors.core
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [ui.typography :as typography]))

(def development?
  ^boolean goog.DEBUG)

(defn error-page []
  [:div {:class "p-10 [&_a]:font-medium [&_a]:underline"}
   [:header {:class "mb-6"}
    [typography/h1 "Oops! Something went wrong."]
    [typography/h2 {:class "text-kleene-text-secondary"} "Our app encountered an error it couldn't recover from."]]

   [typography/p
    "Please "
    [:a {:href "#"
         :on-click (fn []
                     (dispatch [:user.events/refresh-browser-window]))} "reload"]
    " the page."]
   (when development?
     [typography/p
      [:a {:href "#"
           :on-click (fn []
                       (dispatch [:app.events/reset-render-error]))}
       "Reset error state"]])])

(defn restricted-page []
  [:div {:class "p-10 text-kleene-text"}
   [typography/h1  "You don't have permissions to see this page"]])

(defn not-supported-page []
  [:div {:class "p-10 text-kleene-text"}
   [typography/h1 "You don't have access to this feature"]])
